(function($) {
	'use strict';
	$.fn.Collection__CreateNew = function() {
		this.each(function() { 
			
			/*
			 * Action: Create a New Collection
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				// Get options
				var overlay = $('#collection--save-to-my-collections').html(); // <= collection-title auto populated from h4.collection-title
				
				// Parse it
				Mustache.parse( overlay );
				var output = Mustache.render( overlay, { 'temp_title' : Front.translations.my_new_collection } );
				
				// Close other overlays
				var timeout = 10;
				if( $('#overlay-white').length > 0 ) {
					
					// Make sure we wait for it to be closed
					timeout = $.Globals.fxSpeed;
					
					// Close the overlay
					$.Globals.closeOverlay();
					
				}
				
				setTimeout( function() {

					// Add it to dom and fade it in
					$.Body.append( output );
					
					// Async
					setTimeout( function() {
						
						// Fade it in
						$.Body.addClass('overlay-white-on');
				
						// Save new $overlay
						var $overlay = $('#overlay-white'),
							$input = $overlay.find('#new-title');
						
						// Highlight input text
						$input.select();
						
						// Listen for form submit
						$overlay.find('form').off('submit.create-collection').on('submit.create-collection', function(e) {
							e.preventDefault();
				
							// Sets listeners on $self
							$.Globals.overlayNotify( $self, Front.translations.saving, Front.translations.collection_saved );

							// Create it
							$.Globals.ajax( 'scspaces_create_new_collection', { ctitle: $input.val() }, function( data ) {
								
								// Track in Google
								$.Globals.track_event( 'Collection Created' );
								
								// Add to list if we have one
								var $grid_list = $('#grid-list');
								if( $grid_list.length > 0 && data.html.length > 0 ) {
									$('#grid-list').prepend( data.html );
								}
								
								// Listen for complete to close overlay then trigger success message
								$self.off('overlay-notify-complete').on('overlay-notify-complete', function() {
									
									$.Globals.closeOverlay();
									
								}).trigger('overlay-notify-success');
								
							});
					
						});
						
						// Add global close overlay listener
						$.Globals.listenForGlobalCloseOverlay();
						
					}, 10 );
				
					
				}, timeout );
				
			});
			
		
		});
		return this;
	};
}(jQuery));